import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  normalizeStyles,
  typographyStyles,
} from "@webs/components-library/theming";

@customElement('webs-cards-general-single')
export class CardsGeneralSingle extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`

    .m-cards-general-single {

    }

    .m-cards-general-single .container {
      max-width: unset;
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      padding-left: 1.2rem;
      border-radius: 8px;
      margin-left: 0;

    }
    .m-cards-general-single .title {
      margin-bottom: 0.4rem;
    }
    .m-cards-general-single .short-description {
      margin: 0 0 1rem 0;
    }

    .bg-grey {
       background: var(--color-light-grey);
    }

    .card {
          max-width: 248px;

    }

    @media only screen and (min-width: 576px) {
    .m-cards-general-single .container {
      max-width: 248px;
      }
    }


    `
  ]

  @property()
  title: string;

  @property({attribute:'short-description'})
  shortDescription: string;

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property({attribute: 'is-grey'})
  isGrey: boolean;

  protected render(): unknown {
    return html`
    <section class="m-cards-general-single ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}
">
      <div part="container" class="container ${this.isGrey ? 'bg-grey' : ''}">
        <div class="card ">
          <h6 class="title">${this.title}</h6>
          <p class="short-description">${this.shortDescription}</p>
          <slot name="description"></slot>
          <slot name="button"></slot>
        </div>
      </div>
    </section>
    `
  }
}
